<template>
  <v-dialog
    v-model="modalVisible"
    content-class="v-dialog--full-height v-dialog--with-navigation layout justify-center"
    :max-width="maxDialogWidth"
  >
    <div
      class="white fill-height d-flex flex-column"
    >
      <div class="flex-grow-1">
        <!--<editor-fold desc="Document editor">-->
        <tiny-mce
          :id="documentType === 'offer' || documentType === 'offer_model' ? 'offer-editor' : undefined"
          :key="documentType === 'offer' || documentType === 'offer_model' ? 'offer-editor' : 'document-editor'"
          v-model="documentContent"
          :readonly="readOnly"
          :width="documentType === 'offer' || documentType === 'offer_model' ? 'auto' : undefined"
        />
        <!--</editor-fold>-->
      </div>
      <div
        class="text-right shrink pa-3"
      >
        <v-btn
          color="grey"
          text
          large
          @click="modalVisible = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          large
          :loading="submitting"
          @click="save"
        >
          <v-icon left>
            check
          </v-icon>
          Create Document
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import Document from '@/models/Document'
  import TinyMce from '@/components/helpers/TinyMce'

  export default {
    name: 'NewDocumentDialog',
    components: {
      TinyMce
    },
    props: {
      visible: Boolean,
      content: {
        type: String,
        default: null
      },
      templateId: {
        type: Number,
        default: null
      },
      documentType: {
        type: String,
        default: null
      },
      yachtId: {
        type: Number,
        default: null
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      forceShowEquipmentPrice: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        documentContent: this.content,
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      maxDialogWidth() {
        // todo: type should go into Document model
        return this.documentType === 'offer' || this.documentType === 'offer_model' ? '34cm' : '22cm'
      }
    },
    watch: {
      content: function () {
        this.documentContent = this.content
      }
    },
    methods: {
      async save() {
        this.submitting = true

        let data = {
          yacht_id: this.yachtId || undefined,
          html: this.documentContent,
          type: this.documentType,
          template_id: this.templateId || undefined,
          show_equipment_price: this.forceShowEquipmentPrice
        }

        try {
          let document = await Document.api.generateDocument(data)
          this.modalVisible = false

          this.$emit('document:created', document)

          this.$store.dispatch('alert', {
            'text': 'Document created.',
            'color': 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })

          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
